import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumberTransform]',
  standalone: true,
})
export class NumberTransformDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const transformedValue = value
      .replace(/[^0-9.]/g, '') // Remove non-numeric characters except dot
      .replace(/(\..*?)\..*/g, '$1') // Allow only one dot
      .replace(/(\.\d{2})\d+/g, '$1'); // Allow up to 2 decimal places
    this.ngControl.control?.setValue(transformedValue, { emitEvent: false });
  }
}
